/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import colors from '../../../assets/colors';

export const Container = styled.div`
  width: 70%;
  max-width: 400px;
  height: 100%;
  background: #222;
  box-shadow: ${props => (props.show && '0 0 20px rgba(0, 0, 0, 0.5)')};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  transform: ${props => (props.show ? 'translateX(0)' : 'translate(-110%)')};
  transition: transform 0.3s ease-out;
`;

export const NavBar = styled.nav`
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li > a {
    display: flex;
    padding: 10px 15px;
    color: #777777;
    font-size: 0.9rem;
    font-weight: 600;
    text-decoration: none;
  }

  .active, a:hover {
    color: ${colors.white};
    background: ${colors.primary};
  }
`;

export const StoreInfo = styled.div`
  background-color: #2B2B2B;
  padding: 14px;

  display: flex;
  flex-direction: 'row';
  align-items: center;
  
  h2 {
    color: ${colors.white};
    font-size: 0.95rem;
    font-weight: 600;
    margin: 0 0 2px;
    letter-spacing: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    display: block;
  }

  .store-available {
    width: 100%;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    text-align: left;
    cursor: ${props => (props.roleType !== 'employee' && !props.blocked ? 'pointer' : 'default')};
    
    span {
      color: #777777;
      font-family: 'Open Sans', sans-serif;
      font-size: 0.8rem;
      border-bottom: 1px solid;
      height: 1.0rem;
    }

    .fa-circle {
      color: ${colors.primary};
      font-size: 7px;
      padding-right: 7px;
    }

    .fa-circle.closed { color: #FFC107; }
    .fa-circle.unavailable { color: ${colors.red}; }

    :hover { opacity: ${props => (props.roleType !== 'employee' && !props.blocked ? 0.8 : 1)} }
  }
`;


export const Avatar = styled.img`
  width: 35px;
  height: 35px;
  margin-right: 12px;
  border-radius: 50px;
  border: 4px solid #222;
`;
